import { useSearchParams } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import StickyMobileCTA from "@/components/StickyMobileCTA";
import LeadForm from "@/components/LeadForm";
import Disclosure from "@/components/Disclosure";

export default function GetStartedPage() {
    const [params] = useSearchParams();
    const zip = params.get("zip") || "";
    const src = params.get("src") || params.get("utm_source") || "website";
    return (
        <div className="min-h-screen" data-testid="get-started-page">
            <Navbar />
            <section className="max-w-4xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
                <span className="chip">Lead request</span>
                <h1 className="mt-3 text-3xl sm:text-4xl font-extrabold tracking-tight text-white">
                    Let's find your options.
                </h1>
                <p className="mt-2 text-slate-400 max-w-2xl">
                    Answer a few quick questions and a real person will follow up. Your info is
                    only used to help you compare plans - we don't spam.
                </p>
                <div className="mt-8">
                    <LeadForm initial={{ zip_code: zip }} source={src} />
                </div>
                <div className="mt-8">
                    <Disclosure />
                </div>
            </section>
            <Footer />
            <StickyMobileCTA />
        </div>
    );
}
